/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ModuleLogo from './module-logo';
import ModuleLogoDetail from './module-logo-detail';
import ModuleLogoUpdate from './module-logo-update';
import ModuleLogoDeleteDialog from './module-logo-delete-dialog';

const ModuleLogoRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ModuleLogo />} />
    <Route path="new" element={<ModuleLogoUpdate />} />
    <Route path=":id">
      <Route index element={<ModuleLogoDetail />} />
      <Route path="edit" element={<ModuleLogoUpdate />} />
      <Route path="delete" element={<ModuleLogoDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ModuleLogoRoutes;
